import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function InsuranceCarriers() {
  const titleRef = useScrollAnimation();
  const contentRef = useScrollAnimation();

  const carriers = [
    'Blue Cross Blue Shield',
    'UnitedHealthcare',
    'Aetna',
    'Cigna',
    'Humana',
    'Oscar Health',
    'Ambetter',
    'Molina Healthcare',
    'Friday Health Plans',
    'Bright Health',
    'Celtic Insurance',
    'National General',
    'Pivot Health',
    'IHC Group',
    'HealthMarkets',
    'Golden Rule',
    'Assurant Health',
    'Everest Reinsurance',
    'Companion Life',
    'Manhattan Life'
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <h2 
          ref={titleRef.ref}
          className={`text-4xl md:text-5xl font-serif font-bold text-center text-primary mb-4 transition-all duration-1000 ${
            titleRef.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          Insurance Carriers We Work With
        </h2>
        <p className="text-center text-lg text-gray-600 mb-12 max-w-3xl mx-auto">
          As an independent agency, we partner with over 20 top-rated insurance carriers to bring you the best coverage options
        </p>

        <div 
          ref={contentRef.ref}
          className={`transition-all duration-1000 delay-200 ${
            contentRef.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-6 mb-12">
            {carriers.map((carrier, index) => (
              <div 
                key={index}
                className="bg-gray-50 rounded-lg p-6 flex items-center justify-center text-center hover:shadow-lg transition-shadow"
              >
                <span className="text-sm font-semibold text-gray-700">{carrier}</span>
              </div>
            ))}
          </div>

          <div className="bg-primary/5 rounded-lg p-8 border-l-4 border-primary">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-information-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-primary mb-3">Why Choose an Independent Agency?</h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Unlike captive agents who work for a single insurance company, we're an independent agency that works for YOU. This means we can shop multiple carriers to find you the best coverage at the most competitive rates.
                </p>
                <ul className="space-y-2">
                  <li className="flex items-start gap-3 text-gray-700">
                    <i className="ri-check-line text-accent text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>More Options:</strong> Access to 20+ carriers means more plan choices</span>
                  </li>
                  <li className="flex items-start gap-3 text-gray-700">
                    <i className="ri-check-line text-accent text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Better Rates:</strong> We compare prices to find you the best value</span>
                  </li>
                  <li className="flex items-start gap-3 text-gray-700">
                    <i className="ri-check-line text-accent text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Unbiased Advice:</strong> We recommend what's best for you, not what pays us the most</span>
                  </li>
                  <li className="flex items-start gap-3 text-gray-700">
                    <i className="ri-check-line text-accent text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>One-Stop Shop:</strong> All your insurance needs handled by one trusted advisor</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
